import Header from "@/components/marketing/Header";
import Hero from "@/components/marketing/Hero";
import Demo from "@/components/marketing/Demo";
import WhoItsFor from "@/components/marketing/WhoItsFor";
import HowItWorks from "@/components/marketing/HowItWorks";
import Pricing from "@/components/marketing/Pricing";
import SecondExample from "@/components/marketing/SecondExample";
import FinalCta from "@/components/marketing/FinalCta";
import Footer from "@/components/marketing/Footer";

export default function Marketing() {
  return (
    <div className="min-h-screen bg-white font-sans" data-testid="marketing-homepage">
      <Header />
      <main>
        <Hero />
        <Demo />
        <WhoItsFor />
        <HowItWorks />
        <Pricing />
        <SecondExample />
        <FinalCta />
      </main>
      <Footer />
    </div>
  );
}
